import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useMemo } from 'react';
import clsx from 'clsx';
import { addUnit } from '../utils';
import Badge from '../badge';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

function isImage(name) {
  return name ? name.indexOf('/') !== -1 : false;
}

var Icon = function Icon(props) {
  var _useContext = useContext(ConfigProviderContext),
      iconPrefix = _useContext.iconPrefix;

  var tag = props.tag,
      name = props.name,
      className = props.className,
      onClick = props.onClick,
      onTouchStart = props.onTouchStart,
      spin = props.spin;
  var imageIcon = isImage(name);
  var classPrefix = useMemo(function () {
    return props.classPrefix || iconPrefix;
  }, [props.classPrefix, iconPrefix]);
  return /*#__PURE__*/React.createElement(Badge, _extends({
    tag: tag,
    className: clsx(classPrefix, imageIcon ? '' : "".concat(classPrefix, "-").concat(name), className, _defineProperty({}, "".concat(classPrefix, "--spin"), spin)),
    style: _objectSpread({
      color: props.color,
      fontSize: addUnit(props.size)
    }, props.style),
    onClick: onClick,
    onTouchStart: onTouchStart
  }, props.badge), props === null || props === void 0 ? void 0 : props.children, imageIcon && /*#__PURE__*/React.createElement("img", {
    className: clsx('van-icon__image'),
    src: name,
    alt: name
  }));
};

Icon.defaultProps = {
  tag: 'i'
};
export default Icon;